import React from 'react';
import { Table, Tag, Button, Space, Popconfirm, Tooltip } from 'antd';
import { EditOutlined, DeleteOutlined, LockOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';
import PermissionGuard from '../../../../components/auth/PermissionGuard';

const UldTagTable = ({ 
    tags = [], 
    loading = false, 
    onEdit, 
    onDelete,
    pagination,
    onChange 
}) => {
    
    const columns = [
        {
            title: '标签名称',
            dataIndex: 'tag_name',
            key: 'tag_name',
            width: 150,
            render: (tagName, record) => (
                <Tag 
                    color={record.color_code} 
                    style={{ fontSize: '13px', padding: '4px 8px' }}
                >
                    {tagName}
                    {record.is_system_tag && (
                        <LockOutlined style={{ marginLeft: 4, fontSize: '12px' }} />
                    )}
                </Tag>
            ),
        },
        {
            title: '描述',
            dataIndex: 'description',
            key: 'description',
            ellipsis: {
                showTitle: false,
            },
            render: (description) => (
                <Tooltip placement="topLeft" title={description}>
                    {description || '-'}
                </Tooltip>
            ),
        },
        {
            title: '颜色代码',
            dataIndex: 'color_code',
            key: 'color_code',
            width: 100,
            render: (colorCode) => (
                <Space>
                    <div 
                        style={{ 
                            width: 16, 
                            height: 16, 
                            backgroundColor: colorCode,
                            border: '1px solid #d9d9d9',
                            borderRadius: '2px',
                            display: 'inline-block'
                        }} 
                    />
                    <span style={{ fontSize: '12px', color: '#666' }}>
                        {colorCode}
                    </span>
                </Space>
            ),
        },
        {
            title: 'IATA状态码',
            dataIndex: 'iata_equivalent_status',
            key: 'iata_equivalent_status',
            width: 120,
            render: (status) => status ? (
                <Tag color="blue" style={{ fontSize: '12px' }}>
                    {status}
                </Tag>
            ) : '-',
        },
        {
            title: '类型',
            dataIndex: 'is_system_tag',
            key: 'is_system_tag',
            width: 80,
            render: (isSystem) => isSystem ? (
                <Tag color="orange" icon={<LockOutlined />}>
                    系统
                </Tag>
            ) : (
                <Tag color="green">
                    自定义
                </Tag>
            ),
        },
        {
            title: '创建时间',
            dataIndex: 'created_at',
            key: 'created_at',
            width: 150,
            render: (createTime) => dayjs(createTime).format('YYYY-MM-DD HH:mm'),
        },
        {
            title: '操作',
            key: 'actions',
            width: 120,
            fixed: 'right',
            render: (_, record) => (
                <Space size="small">
                    <PermissionGuard permission="uld:tag:manage">
                        <Button
                            type="text"
                            size="small"
                            icon={<EditOutlined />}
                            onClick={() => onEdit(record)}
                            title="编辑标签"
                        />
                    </PermissionGuard>
                    <PermissionGuard permission="uld:tag:manage">
                        <Popconfirm
                            title="确认删除"
                            description={`确定要删除标签"${record.tag_name}"吗？${record.is_system_tag ? ' (这是系统标签)' : ''}`}
                            onConfirm={() => onDelete(record.id)}
                            okText="确定"
                            cancelText="取消"
                        >
                            <Button
                                type="text"
                                size="small"
                                icon={<DeleteOutlined />}
                                danger
                                title={record.is_system_tag ? "删除系统标签" : "删除标签"}
                            />
                        </Popconfirm>
                    </PermissionGuard>
                </Space>
            ),
        },
    ];

    return (
        <Table
            columns={columns}
            dataSource={tags}
            rowKey="id"
            loading={loading}
            pagination={{
                ...pagination,
                showSizeChanger: true,
                showQuickJumper: true,
                showTotal: (total, range) => 
                    `第 ${range[0]}-${range[1]} 条，共 ${total} 条标签`,
                pageSizeOptions: ['10', '20', '50', '100'],
            }}
            onChange={onChange}
            scroll={{ x: 800 }}
            size="middle"
            bordered
        />
    );
};

export default UldTagTable; 